import { useGeneralData } from "modules/moduleTemplates/components/ModuleDetailsDrawer/stores/useGeneralData";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { COLOR_BLACK } from "shared/theme/colors";
import { isValidUrl } from "./validation";

const FIELD_ID = "base-url";

const ProductIframeSection = () => {
  const { baseUrl, setBaseUrl, isInvalidBaseUrl, setInvalidBaseUrl } =
    useGeneralData();

  const onChangeBaseUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setInvalidBaseUrl(false);
    return setBaseUrl(value);
  };

  const onCheckValidation = () => {
    if (!isValidUrl(baseUrl)) {
      return setInvalidBaseUrl(true);
    }

    setInvalidBaseUrl(false);
  };

  const errors = isInvalidBaseUrl
    ? [{ key: FIELD_ID, message: "Link is invalid" }]
    : [];

  return (
    <ContentSection title="MODULE CONFIGURATION">
      <FlexColumn>
        <TextField
          id={FIELD_ID}
          label={"Base url"}
          labelColor={COLOR_BLACK}
          value={baseUrl}
          onChange={onChangeBaseUrl}
          onBlur={onCheckValidation}
          errors={errors}
        />
      </FlexColumn>
    </ContentSection>
  );
};

export default ProductIframeSection;
